import React from "react";  
const footer = () => {
  return (
    <footer className="footer">
      <div></div>
    </footer>
  );
};
export default footer;
